<template>
  <v-container class="page ma-auto">
    <div class="ma-auto image-container">
      <img 
        class="mt-4" 
        src="/static/img/Logo MM.png"
        contain
      >
    </div>
    <div>
      <h1 class="name-surname header mt-4">{{ imieUczestnika }} {{nazwiskoUczestnika}}</h1>
    </div>
    <div>
      <h3 class="camp-date header">{{ termin() }}</h3>
    </div>
    <div>
      <h4 class="transport header mt-3">{{ dojazdSubstring() }}</h4>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'KartaBagaz',
  props: {
  },
  data () {
    return {
      terminWyjazdu: '',
      imieUczestnika: '',
      nazwiskoUczestnika: '',
      dojazd: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    termin() {
      const searchTerm = 'Camp';
      const indexOfFirst = this.terminWyjazdu.indexOf(searchTerm);
      let terminWyjazdu = this.terminWyjazdu.substring(indexOfFirst);
      return terminWyjazdu;
    },
    dojazdSubstring() {
      const indexOfFirst = this.dojazd.indexOf('(');
      let dojazd = this.dojazd.substring(0, indexOfFirst).trim();
      return dojazd;
    }
  },
  mounted () {
    if (this.imieUczestnika) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>

.image-container {
  width: 400px;
}

.header {
  text-align: center;
}

.name-surname {
  font-size: 90px;
  letter-spacing: 10px;
}

.camp-date {
  font-size: 60px;
  margin-top: 50px;
}

.transport {
  font-size: 60px;
  margin-top: 10px;
}

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/KartaBagaz.vue